module.exports = __webpack_public_path__ + "static/media/inProgressIcon.9a7a7a93.svg";